import { UNIT_LABELS } from "../lib/utils";
import type { SpeedUnit } from "../lib/types";
import styles from "./UnitButton.module.css";

interface UnitButtonProps {
  unit: SpeedUnit;
  onClick: () => void;
  id?: string;
}

/**
 * Cycles between kn / ms / km/h / mph. Stateless — pass `unit` and `onClick`
 * from the parent (typically useUnit()).
 */
export function UnitButton({ unit, onClick, id }: UnitButtonProps) {
  return (
    <button type="button" className={styles.unitBtn} id={id} onClick={onClick}>
      {UNIT_LABELS[unit]}
    </button>
  );
}
